
export enum DateTypeEnum {
    week,
    month,
    year,
    custom
}